"use strict";

exports.__esModule = true;
exports.default = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var primaryColors = {
  newKinedu: '#0086D8',
  newKineduLight: '#EAF5FC',
  kinedu: '#278ECD',
  oldkinedu: '#1B75BB',
  kineduShade: '#165E96',
  kineduShadeDark: '#134F7D'
};
var secondaryColors = {
  interactive: '#0E3687',
  physicalDark50: '#085670',
  physicalDark20: '#0689B4',
  physical: '#32AFE0',
  physicalLight30: '#5DC5EA',
  physicalLight50: '#8CD6F0',
  physicalLight70: '#BBE6F6',
  physicalLight80: '#D9F5FF',
  cognitiveDark50: '#395C26',
  cognitiveDark20: '#5B933D',
  cognitive: '#3EB646',
  cognitiveLight30: '#9DCD83',
  cognitiveLight50: '#B9DCA7',
  cognitiveLight70: '#D4EACA',
  cognitiveLight80: '#E9FFDF',
  socialEmotionalDark50: '#6A1838',
  socialEmotionalDark20: '#AB275A',
  socialEmotional: '#D1296D',
  socialEmotionalLight30: '#E26F9B',
  socialEmotionalLight50: '#EB99B8',
  socialEmotionalLight70: '#F3C1D4',
  linguisticDark50: '#7C4604',
  linguisticDark20: '#C77100',
  linguistic: '#F99848',
  linguisticLight30: '#FBB15D',
  linguisticLight50: '#FCC78C',
  linguisticLight70: '#FDDDBA',
  healthDark50: '#730000',
  healthDark20: '#B90000',
  health: '#E50000',
  healthLight30: '#EF4B48',
  healthLight50: '#F47F7E',
  healthLight70: '#F8B3B2',
  webinar: '#913FA3'
};
var neutralShades = {
  shadeLighter: '#F8F8F8',
  shadeLight: '#F0F0F0',
  shadeMediumLight: '#CFD5DA',
  shadeMedium: '#ACC2D3',
  shadeMediumDark: '#8295A3',
  shadeDark: '#657480',
  shadeDarker: '#2C343A'
};
var otherColors = {
  white: '#FFFFFF',
  whiteAlpha: 'rgba(255, 255, 255, 0.5)',
  blackAlpha: 'rgba(0, 0, 0, 0.5)',
  darkGray: '#4A4A4A',
  lightGray: '#F4F4F4',
  whiteBluish: '#E2E8EC',
  whiteBluish2: '#D7E3E8',
  dustyGray: '#9B9B9B',
  borderGray: '#b5b5b5',
  borderGrayOpacity: 'rgba(151,151,151,0.5)',
  iconGray: '#D5D5D5',
  lighterGray: '#E2E2E2',
  silver: '#CCCCCC',
  gold: '#F8E71C',
  trophyYellow: '#FFC200',
  // error: '#D0021B',
  errorNeo: '#e46f89',
  warmWhite: '#F8F1F3',
  transparent: 'transparent',
  fakeMultiplayBlue: '#17364E',
  multiplyBlue: '#9cb5ca'
};

var kineduColorPalette = _extends({}, primaryColors, secondaryColors, neutralShades);

var miscColors = _extends({
  facebook: '#3b5998',
  excel: '#197C43',
  boy: '#1FADDF',
  girl: '#F14B8A',
  materials: '#F78E21',
  error: '#E50000',
  lavender: '#a29cff'
}, otherColors);

var aldeaColorPalette = {
  red: '#ff0000',
  pink: '#ED005E',
  orange: '#F46A00',
  blue: '#4ABFE7',
  green: '#7DC421',
  greenpretty: '#66f446',
  white: '#fff',
  black: '#000',
  yellow: '#ECD90B',
  greenalt: '#d1da4b',
  purple: '#954EA6'
};
var allColors = {
  KineduPalette: kineduColorPalette,
  AldeaPalette: aldeaColorPalette,
  MiscPalette: miscColors
};
var _default = allColors;
exports.default = _default;